// import something here
import VueNativeSock from 'vue-native-websocket';
// import store from '../store';
// leave the export, even if you don't use it
export default ({ Vue }) => {
  // something to do
  Vue.use(VueNativeSock, `${process.env.wsUrl}/inform`, {
    connectManually: true,
  });
};



// WEBPACK FOOTER //
// ./src/plugins/websocket.js